// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"7b62deb8","227":"83084ecb","606":"b8c5354b","627":"190a97c1","650":"5d3c6da0","740":"2e5e5edf","761":"12da6421","870":"08e8e569"}[chunkId] + ".chunk.js";
};